import basicController from "servicestack/basic.controller.properties";
import labels from "emun.order/_labels";
import orderConfig from "emun.order/order.config";
import cartConfig from "emun.cart/cart.config";

export default class CartItemShipDateController {
	constructor() {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.labels = labels;
		$ctrl.config = cartConfig;
		$ctrl.orderConfig = orderConfig;
		$ctrl.cartItem.minShipDate = $ctrl.$cart.today;
		//console.debug("$ctrl.product", $ctrl.product);
		if ($ctrl.cartItem.product && moment.utc($ctrl.cartItem.product.shipOn) > $ctrl.$cart.today) {
			//console.debug("Dates Logic", moment.utc($ctrl.cartItem.product.shipOn), moment.utc($ctrl.cartItem.product.availableOn));
			if (!$ctrl.config.allowEarlyProductShipDate) $ctrl.cartItem.minShipDate = moment.utc($ctrl.cartItem.product.shipOn);
			if ($ctrl.config.allowAvailableShipDate == true && $ctrl.cartItem.product.availableOn && moment.utc($ctrl.cartItem.product.shipOn) > moment.utc($ctrl.cartItem.product.availableOn)) {
				$ctrl.cartItem.minShipDate = moment.utc($ctrl.cartItem.product.availableOn);
			}
			
		}
		if (!$ctrl.cartItem.product && $ctrl.product && moment.utc($ctrl.product.shipOn) > $ctrl.$cart.today) {
			//console.debug("Dates Logic", moment.utc($ctrl.cartItem.product.shipOn), moment.utc($ctrl.cartItem.product.availableOn));
			if (!$ctrl.config.allowEarlyProductShipDate) $ctrl.cartItem.minShipDate = moment.utc($ctrl.product.shipOn);
			if ($ctrl.config.allowAvailableShipDate === true && $ctrl.product.availableOn && moment.utc($ctrl.product.shipOn) > moment.utc($ctrl.product.availableOn)) {
				$ctrl.cartItem.minShipDate = moment.utc($ctrl.product.availableOn);
			}

		}

		const items = _.sortBy($ctrl.$cart.items, 'shipOn');
		const shipDates =items.map(item =>
			moment.utc(item.shipOn).format("MM/DD/YYYY")
		);
		$ctrl.actions = _.uniq(shipDates).map(shipdate => ({
			title: shipdate,
			key: shipdate
		}));
		//$ctrl.actions = _.sortBy($ctrl.actions, 'key');
		$ctrl.cartItem.shipOn = moment.utc($ctrl.cartItem.$shipOn);
	}

	submit() {
		const $ctrl = this;
		$ctrl.$close($ctrl.cartItem);
//		$ctrl.$cart.changeOptions($ctrl.cartItem).then(res => $ctrl.$close(res));
	}

	setDate(date) {
		const $ctrl = this;
		$ctrl.cartItem.shipOn = moment.utc(date);
	}
}
